export const ACCEPT_IMAGE_INPUT = 'image/jpeg,image/png,image/tiff,image/webp,.jpg,.jpeg,.png,.tif,.tiff,.webp'
export const MAX_IMAGE_UPLOAD_BYTES = 150 * 1024 * 1024
export const MAX_IMAGE_UPLOAD_MB = 150

export function isAcceptedImageFile(file: File): boolean {
    const type = String(file?.type || '').toLowerCase()
    if (['image/jpeg', 'image/png', 'image/tiff', 'image/webp'].includes(type)) return true

    const name = String(file?.name || '').toLowerCase()
    return (
        name.endsWith('.jpg')
        || name.endsWith('.jpeg')
        || name.endsWith('.png')
        || name.endsWith('.tif')
        || name.endsWith('.tiff')
        || name.endsWith('.webp')
    )
}

export function isAcceptedImageUploadFile(file: File, maxBytes: number = MAX_IMAGE_UPLOAD_BYTES): boolean {
    if (!isAcceptedImageFile(file)) return false
    return Number(file?.size || 0) > 0 && Number(file.size) <= maxBytes
}
